var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "management-section-wrapper" },
        [
          _c(
            "v-card-title",
            [
              _c(
                "span",
                {
                  staticClass: "management-section-title",
                  staticStyle: { color: "#000000" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("WorkspaceSelection")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              !_vm.loading
                ? _c("v-text-field", {
                    staticClass: "data-table-search",
                    attrs: {
                      value: _vm.searchFromParent,
                      "append-icon": "search",
                      label: _vm.$t("Search"),
                      placeholder: _vm.$t("Search"),
                      "single-line": "",
                      "hide-details": ""
                    },
                    on: { input: _vm.updateSearchInParent }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("v-data-table", {
            class: { "no-show-permission": !_vm.userHasPermissionTo("show") },
            attrs: {
              headers: _vm.headers,
              items: _vm.filterWorkspaces,
              loading: _vm.loading,
              "loading-text": "",
              page: _vm.pagination.page,
              "sort-by": _vm.pagination.sortBy,
              "sort-desc": _vm.pagination.descending,
              "items-per-page": _vm.paginationWorkspacesList.rowsPerPage,
              "items-per-page-text": _vm.rowsPerPageText,
              "items-per-page-items": _vm.rowsPerPageItems,
              "footer-props": {
                prevIcon: _vm.prevIcon,
                nextIcon: _vm.nextIcon,
                "items-per-page-options": _vm.rowsPerPageItems
              },
              "hide-default-header": "",
              id: "workspace-list"
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.pagination, "page", $event)
              },
              "update:itemsPerPage": function($event) {
                return _vm.$set(
                  _vm.paginationWorkspacesList,
                  "rowsPerPage",
                  $event
                )
              },
              "update:items-per-page": function($event) {
                return _vm.$set(
                  _vm.paginationWorkspacesList,
                  "rowsPerPage",
                  $event
                )
              },
              pagination: function($event) {
                return _vm.setRowsOnLocalStorage(
                  _vm.dataTableWorkspacesListId,
                  _vm.paginationWorkspacesList.rowsPerPage
                )
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function() {
                    return [
                      _c("thead", [
                        _c(
                          "tr",
                          [
                            _c(
                              "table-header-cell",
                              {
                                staticStyle: { "padding-left": "39px" },
                                attrs: {
                                  header: _vm.headers[0],
                                  pagination: _vm.pagination,
                                  filterActive: !!_vm.filters.label,
                                  "sort-icon":
                                    _vm.pagination.descending &&
                                    _vm.headers[0].value ===
                                      _vm.pagination.sortBy
                                      ? "arrow_drop_up"
                                      : "arrow_drop_down"
                                },
                                on: { sort: _vm.changeSort }
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "text-field",
                                  attrs: {
                                    label: _vm.$tc("Label", 1),
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.filters.label,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "label", $$v)
                                    },
                                    expression: "filters.label"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "table-header-cell",
                              {
                                attrs: {
                                  header: _vm.headers[1],
                                  pagination: _vm.pagination,
                                  filterActive: !!_vm.filters.plan_name,
                                  "sort-icon":
                                    _vm.pagination.descending &&
                                    _vm.headers[1].value ===
                                      _vm.pagination.sortBy
                                      ? "arrow_drop_up"
                                      : "arrow_drop_down"
                                },
                                on: { sort: _vm.changeSort }
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "text-field",
                                  attrs: {
                                    label: _vm.$t("PlanName"),
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.filters.plan_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "plan_name", $$v)
                                    },
                                    expression: "filters.plan_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "table-header-cell",
                              {
                                attrs: {
                                  header: _vm.headers[2],
                                  pagination: _vm.pagination,
                                  filterActive: !!_vm.filters.phase,
                                  "sort-is-disabled": true
                                },
                                on: { sort: _vm.changeSort }
                              },
                              [
                                _c("v-autocomplete", {
                                  staticClass: "text-field",
                                  attrs: {
                                    label: _vm.$t("Phase"),
                                    items: _vm.projectPhaseOptions,
                                    pagination: _vm.pagination,
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.filters.phase,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "phase", $$v)
                                    },
                                    expression: "filters.phase"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "table-header-cell",
                              {
                                attrs: {
                                  header: _vm.headers[3],
                                  pagination: _vm.pagination,
                                  filterActive: !!_vm.filters.manager,
                                  "sort-is-disabled": true
                                },
                                on: { sort: _vm.changeSort }
                              },
                              [
                                _c("v-autocomplete", {
                                  staticClass: "text-field",
                                  attrs: {
                                    label: _vm.$t("Manager"),
                                    items: _vm.getManagerOptions,
                                    pagination: _vm.pagination,
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.filters.manager,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "manager", $$v)
                                    },
                                    expression: "filters.manager"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("table-header-cell", {
                              attrs: {
                                header: _vm.headers[4],
                                pagination: _vm.pagination,
                                "sort-icon":
                                  _vm.pagination.descending &&
                                  _vm.headers[5].value === _vm.pagination.sortBy
                                    ? "arrow_drop_up"
                                    : "arrow_drop_down"
                              },
                              on: { sort: _vm.changeSort }
                            }),
                            _vm._v(" "),
                            _c(
                              "table-header-cell",
                              {
                                attrs: {
                                  header: _vm.headers[5],
                                  pagination: _vm.pagination,
                                  filterActive:
                                    _vm.filters.status !== null &&
                                    _vm.filters.status !== undefined,
                                  "sort-icon":
                                    _vm.pagination.descending &&
                                    _vm.headers[6].value ===
                                      _vm.pagination.sortBy
                                      ? "arrow_drop_up"
                                      : "arrow_drop_down"
                                },
                                on: { sort: _vm.changeSort }
                              },
                              [
                                _c("v-autocomplete", {
                                  staticClass: "text-field",
                                  attrs: {
                                    label: _vm.$t("Status"),
                                    items: _vm.statusOptions,
                                    pagination: _vm.pagination,
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.filters.status,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "status", $$v)
                                    },
                                    expression: "filters.status"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  },
                  proxy: true
                },
                !_vm.loading
                  ? {
                      key: "item",
                      fn: function(props) {
                        return [
                          _c(
                            "tr",
                            {
                              class: {
                                "cursor-pointer": _vm.userHasPermissionTo(
                                  "show"
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setWorkspace(props.item.wp_uuid)
                                }
                              }
                            },
                            [
                              _c("td", [_vm._v(_vm._s(props.item.wp_label))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      props.item.wp_plan_name
                                        ? props.item.wp_plan_name
                                        : "-"
                                    ) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.userHasListPermission
                                ? _c("td", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.getProjectPhaseName(
                                            props.item.wp_status
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  props.item.manager
                                    ? _c("v-layout", [
                                        _c("img", {
                                          staticClass: "avatar data-table-logo",
                                          attrs: {
                                            src: props.item.manager.image
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "data-table-td-content"
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.getName(
                                                    props.item.manager
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(props.item.wp_created_at))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("div", {
                                  staticClass: "user-status-icon",
                                  class: {
                                    "status-inactive": !props.item
                                      .wp_status_active
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        props.item.wp_status_active
                                          ? _vm.$tc("OpenNoun", 1)
                                          : _vm.$tc("ClosedNoun", 1)
                                      ) +
                                      "\n            "
                                  )
                                ])
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  : null,
                {
                  key: "pageText",
                  fn: function(props) {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.pageStart) +
                          " - " +
                          _vm._s(props.pageStop) +
                          " " +
                          _vm._s(_vm.$t("tables.Of")) +
                          "\n        " +
                          _vm._s(props.itemsLength) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "no-data",
                  fn: function() {
                    return [
                      _vm.loading
                        ? _c("div")
                        : _c(
                            "v-alert",
                            {
                              staticClass: "data-table-no-data",
                              attrs: { icon: "warning" }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("NoDataWorkspace")) +
                                  "\n        "
                              )
                            ]
                          )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2960d18d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2960d18d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Workspaces/WorkspacesList.vue
// module id = null
// module chunks = 